import { createStyles } from "@mantine/emotion";

export default createStyles ( () => ( {
	skeletonContainer: {
		margin: "3rem auto"
	}
} ) );